import React, { Component } from "react";
import { Grid, Box, CardContent, CardMedia, Button } from "@mui/material";
import CtTxt from "./CustomTool/CtTxt";
import CtDtp from "./CustomTool/CtDtp";
import CtTxtAmt from "./CustomTool/CtTxtAmt";
import CtTxtNum from "./CustomTool/CtTxtNum";
import CtCmb from "./CustomTool/CtCmb";
import TextAreaAutoSize from "./CustomTool/TextAreaAutoSize";
import CtBtn from "./CustomTool/CtBtn";
import { Edit, Delete, ThirtyFpsSharp } from "@mui/icons-material";
import CtMultiLineText from "./CustomTool/CtMultiLineText";
import { withRouter } from "../HOC/withRouter";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import { connect } from "react-redux";
import Progress from "./CustomTool/Progress";
import {
  mapStatetoProps,
  mapSetActiveMenuToProps,
} from "../mapRedux/mapReduxProps";
import { fetchLoadUnload, fetchComagentDetail } from "./API";
import {
  get_YMD_from_SYS,
  get_30DaysBack_FromCurrentDate,
  isValidItem,
  getlocalstoragedate,
  setlocalstoragedate,
  applyTrimOnObjectValues,
  csvFileName,
} from "../SystemUtility/SystemUtility";
import TableList from "./CustomTool/TableList";
import VehicleUnload from "./VehicleUnload";
import CtCmbEditable from "./CustomTool/CtCmbEditable";
import ResetDate from "../images/resetdate.png";
import MaterialTable from "./CustomTool/MaterialTable";

import TripItemEntry from "./TripItemEntry";

class CommisionAgentMaster extends Component {
  state = {
    formData: {
      int_comagentcode: 0,
      vac_comagentname: "",
      txtagentcode: 0,
      txtagentname: "",
      Commission: "",
    },
    columns: [
      {
        accessorKey: "int_comagentcode",
        header: "કમિશન એજન્ટ કોડ",
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
        size: 50,
      },
      {
        accessorKey: "vac_comagentname",
        header: " કમિશન એજન્ટ નામ",
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
        size: 500,
      },
    ],
    rows: [],
    rowsCount: 0,
    rowsPerPage: 50,
    // counter: 0,
    dataLoadStatus: true,
    ARD: null,
  };

  componentDidMount() {
    {
      !this.props.showHeading &&
        (document.title = "RiTe Account :કમિશન એજન્ટ માસ્ટર");
    }
    this.props.setActiveMenu("CommisionAgentEntry");
    this.props.verifyUserID(
      this.onFormLoad,
      this.props.navInfo.subMenuMaster,
      this.props.setSubMenu_Master_Entry,
      this.props.setUserPrivileges
    );
  }

  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };

  handleChangeRowsPerPageOtherDetail = (rowsPerPageOtherDetail) => {
    this.setState({ rowsPerPageOtherDetail });
  };

  handleARDonActionClick_Delete = (row) => {
    const int_comagentcode = row.getValue("int_comagentcode"),
      Commision = row.getValue("vac_comagentname");
    this.DeleteData(int_comagentcode, Commision);
  };

  DeleteData = (int_comagentcode, Commision) => {
    if (int_comagentcode > 0) {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={
              "Do you want to Delete Commision Agent Name : " + Commision + " ?"
            }
            alertMessage=""
            handleOnClickYes={() => {
              this.DeleteComagent(int_comagentcode);
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );
        this.setState({ ARD });
      });
    } else {
      this.props.toastErrorMsg("Select a record for deletion.");
    }
  };

  DeleteComagent = (int_comagentcode) => {
    this.props.notifyProcessing();
    this.setState({ dataLoadStatus: false }, () => {
      const reqData = {
        Op: "DeleteComagent",
        bint_acid: localStorage.getItem("acid"),
        int_comagentcode: int_comagentcode,
        bol_list: true,
      };
      fetchComagentDetail(reqData).then((res) => {
        this.props.updateProcessing(res.data.msgType, res.data.message);
        if (res.data.msgType === "success") {
          let rows = [],
            rowsCount = rows.length;
          if (res.data.ComagentList && res.data.ComagentList.length > 0) {
            rows = res.data.ComagentList;
            rowsCount = rows.length;
          }
          this.setState(
            {
              dataLoadStatus: true,
              rows,
              rowsCount,
              ARD: null,
            },
            () => {
              // this.onFormLoad();
              this.clearInfo();
            }
          );
          document.getElementById("txtagentname").focus();
        }
      });
      // .catch((error) => {
      //   this.props.updateProcessing(
      //     "error",
      //     "Unknown error occurred in delete Check list. " + error
      //   );
    });
    return false;
  };

  handleChangeRowsPerPage = (rowsPerPage) => {
    this.setState({ rowsPerPage });
  };

  handleOnRowDataChange = (rows, handledRowIndex, colID) => {
    this.setState({ rows, rowsCount: rows.length }, () => {});
  };

  onFormLoad = () => {
    let dataLoadStatus = false;
    this.setState({ dataLoadStatus }, () => {
      let reqData = {
        Op: "LoadComagent",
        bint_acid: localStorage.getItem("acid"),
        int_comagentcode: this.state.formData.txtagentcode,
      };
      fetchComagentDetail(reqData)
        .then((res) => {
          dataLoadStatus = true;
          let txtagentcode = res.data.nextComagentcode,
            rows = [],
            rowsCount = 0;

          if (res.data.ComagentList && res.data.ComagentList.length > 0) {
            rows = res.data.ComagentList;
            rowsCount = rows.length;
          }
          this.setState({
            dataLoadStatus,
            rows,
            formData: {
              ...this.state.formData,
              txtagentcode,
            },
            rowsCount,
          });
        })
        .catch((error) => {
          console.error("Unknown error occurred in onFormLoad.", error);
        });
    });
    document.getElementById("txtagentname").focus();
  };

  clearInfo = () => {
    let int_comagentcode = "",
      txtagentname = "";
    this.props.notifyProcessing();
    const reqData = {
      Op: "LoadComagent",
      bint_acid: localStorage.getItem("acid"),
      int_comagentcode: 0,
    };
    fetchComagentDetail(reqData)
      .then((res) => {
        this.props.closeUpdateProcessing();
        this.setState({
          formData: {
            ...this.state.formData,
            txtagentcode: res.data.nextComagentcode,
            int_comagentcode,
            txtagentname,
          },
        });
      })
      .catch((error) => {
        console.log("Unknown error occurred in onFormLoad.", error);
      });
    document.getElementById("txtagentname").focus();
  };

  validateCommissionAgent = () => {
    let result = false;
    if (this.state.formData.txtagentcode == "") {
      this.props.toastErrorMsg(" કમિશન એજન્ટ કોડ ઉમેરો", "txtagentcode");
    } else if (!this.state.formData.txtagentname.trim()) {
      this.props.toastErrorMsg("કમિશન એજન્ટ નામ ઉમેરો", "txtagentname");
    } else {
      result = true;
    }
    return result;
  };

  SaveComagent = () => {
    if (this.validateCommissionAgent()) {
      let dataLoadStatus = false;
      this.props.notifyProcessing();
      this.setState({ dataLoadStatus: false }, () => {
        const reqData = {
          Op: "SaveComagent",
          bint_acid: localStorage.getItem("acid"), // Ensure it's not null
          int_comagentcode: this.state.formData.txtagentcode, // Handle missing values
          edit_int_comagentcode: this.state.formData.int_comagentcode,
          vac_comagentname: this.state.formData.txtagentname, // Trim whitespace
        };
        fetchComagentDetail(reqData)
          .then((res) => {
            this.props.updateProcessing(res.data.msgType, res.data.message);
            if (res.data.msgType === "success") {
              dataLoadStatus = true;
              let txtagentcode = res.data.nextComagentcode,
                rows = [],
                rowsCount = 0;
              if (res.data.ComagentList && res.data.ComagentList.length > 0) {
                rows = res.data.ComagentList;
                rowsCount = rows.length;
              }
              this.setState(
                {
                  dataLoadStatus,
                  rows,
                  formData: {
                    ...this.state.formData,
                    txtagentcode,
                  },
                  rowsCount,
                },
                // this.clearInfo();
                () => {
                  this.clearInfo();
                }
              );
            } else {
              dataLoadStatus = true;
              this.setState({
                dataLoadStatus,
              });
            }
          })
          .catch((error) => {
            console.log(
              "Unknown error occurred in Save Commision Agent Master.",
              error
            );
          });
      });
    }
  };

  trimFormData = (nextFunctionCall) => {
    let formData = applyTrimOnObjectValues({
      formData: this.state.formData,
      excludeKeysArray: ["chkReceiptGenerated"],
    });
    this.setState({ formData }, () => {
      if (nextFunctionCall) {
        nextFunctionCall();
      }
    });
  };

  handleARDonActionClick_Edit = (row) => {
    console.log("row", row);
    const int_comagentcode = row.getValue("int_comagentcode"),
      txtagentcode = row.getValue("int_comagentcode"),
      txtagentname = row.getValue("vac_comagentname");
    this.setState({
      formData: {
        ...this.state.formData,
        int_comagentcode, // Corrected field
        txtagentcode,
        txtagentname,
      },
    });
    window.scrollTo(0, 0);
    document.getElementById("txtagentname").focus();
  };

  handleOnNewEntryClick = () => {
    let ARD = null;
    this.setState({ ARD }, () => {
      ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          // New : Sales Item Entry'
          alertMessage={<TripItemEntry />}
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
        />
      );
      this.setState({ ARD });
    });
  };

  render() {
    // console.log("this.state.formData", this.state.formData);

    return (
      <form>
        <Progress
          color="primary"
          display={this.state.dataLoadStatus !== true}
        />
        {this.props.showHeading && (
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            className="title"
          >
            <label
              htmlFor="Title"
              style={{ fontSize: "25px", color: "#6f7689" }}
            >
              <b>કમિશન એજન્ટ માસ્ટર</b>
            </label>
          </Grid>
        )}
        <Grid
          container
          direction="column"
          spacing={2}
          marginTop={0}
          justifyContent="center"
          alignItems="center"
        >
          <Grid item>
            <Grid
              container
              direction="row"
              spacing={2}
              marginTop={0}
              justifyContent="center"
              alignItems="flex-start"
            >
              <Grid item>
                <CtTxtNum
                  id="txtagentcode"
                  value={this.state.formData.txtagentcode}
                  handleOnChange={this.handleOnChange}
                  label="કમિશન એજન્ટ કોડ*"
                  width={140}
                  maxLength={100}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtagentname"
                />
              </Grid>
              <Grid item>
                <CtTxt
                  id="txtagentname"
                  value={this.state.formData.txtagentname}
                  handleOnChange={this.handleOnChange}
                  label="કમિશન એજન્ટ નામ*"
                  width={300}
                  maxLength={100}
                  onKeyDown={this.props.onKeyDown}
                  defaultAction={this.SaveComagent}
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              spacing={2}
              justifyContent="center"
              alignItems="flex-start"
              marginTop={0}
              marginLeft={0}
            >
              <Grid item>
                <CtBtn label="Save" onClick={this.SaveComagent} />
              </Grid>

              <Grid item>
                <CtBtn
                  label="New"
                  onClick={this.clearInfo}
                  variant={"outlined"}
                />
              </Grid>

              <Grid item>
                <CtBtn
                  label="Delete"
                  onClick={() => {
                    this.DeleteData(
                      this.state.formData.int_comagentcode,
                      this.state.formData.txtagentname
                    );
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <br />

        <Grid item marginTop={3} className="maintable">
          <MaterialTable
            rowsdata={this.state.rows}
            columnsdata={this.state.columns}
            rowsPerPage={this.state.rowsPerPage}
            tblmaxHeight={500}
            onEditAction={this.handleARDonActionClick_Edit}
            onDeleteAction={this.handleARDonActionClick_Delete}
            showColumnFilters={false}
            // hideColIdList={["int_comagentcode"]}
            actionColSize={30}
            density={"compact"}
          />
        </Grid>
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </form>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenuToProps
)(HOCVerifyIsUser(HoCtToastContainer(withRouter(CommisionAgentMaster))));
